import { render, staticRenderFns } from "./accesstrends.vue?vue&type=template&id=47535695&scoped=true&"
import script from "./accesstrends.vue?vue&type=script&lang=js&"
export * from "./accesstrends.vue?vue&type=script&lang=js&"
import style0 from "./accesstrends.vue?vue&type=style&index=0&id=47535695&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47535695",
  null
  
)

export default component.exports